/*
 * gen90-reviews-carousel.js — prev/next controls for the testimonials track.
 *
 * The track scrolls on its own: it is a flex scroll-snap container, so touch,
 * trackpad and keyboard all work with no script at all. This file adds only the
 * mouse affordance, and it is entirely optional — if it never runs, the controls
 * stay [hidden] and nothing is broken.
 *
 * Mirrors the lifecycle of gen90-sticky-bar.js: an init guard so a section
 * re-render cannot double-bind, AbortController teardown, and
 * shopify:section:load / :unload so the theme editor stays correct.
 *
 * The controls reveal themselves only when the track genuinely overflows, which
 * is what keeps the default three-review layout identical to the pre-carousel
 * version. Overflow is re-measured on resize, because the column count changes
 * with the breakpoint and a wide window can absorb reviews a narrow one cannot.
 */
(function () {
  'use strict';

  var EPSILON = 2; // sub-pixel slack: scrollWidth/clientWidth rarely agree exactly

  function initCarousel(root) {
    if (!root || root.getAttribute('data-gen90-reviews-init') === 'true') { return; }

    var track = root.querySelector('[data-gen90-reviews-track]');
    var nav = root.querySelector('[data-gen90-reviews-nav]');
    if (!track || !nav) { return; }

    var prev = nav.querySelector('[data-gen90-reviews-prev]');
    var next = nav.querySelector('[data-gen90-reviews-next]');
    if (!prev || !next) { return; }

    root.setAttribute('data-gen90-reviews-init', 'true');

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var opts = controller ? { signal: controller.signal } : false;
    root.__gen90Abort = controller;

    function overflows() {
      return track.scrollWidth - track.clientWidth > EPSILON;
    }

    // Hides the whole control row when there is nothing to page through, and
    // disables an individual arrow at each end so the affordance never lies.
    function sync() {
      var scrollable = overflows();
      nav.hidden = !scrollable;
      if (!scrollable) { return; }
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= EPSILON;
      next.disabled = track.scrollLeft >= max - EPSILON;
    }

    // One viewport-width per press, so a click advances exactly the number of
    // cards on screen whatever the column count is.
    function page(direction) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({
        left: direction * track.clientWidth,
        behavior: reduce ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () { page(-1); }, opts);
    next.addEventListener('click', function () { page(1); }, opts);
    track.addEventListener('scroll', sync, controller ? { signal: controller.signal, passive: true } : false);
    window.addEventListener('resize', sync, opts);

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(sync);
      ro.observe(track);
      root.__gen90Obs = ro;
    }

    sync();
  }

  function teardown(scope) {
    var root = scope && scope.querySelector ? scope.querySelector('[data-gen90-reviews-init]') : null;
    if (scope && scope.matches && scope.matches('[data-gen90-reviews-init]')) { root = scope; }
    if (!root) { return; }
    if (root.__gen90Obs) { root.__gen90Obs.disconnect(); root.__gen90Obs = null; }
    if (root.__gen90Abort) { root.__gen90Abort.abort(); root.__gen90Abort = null; }
    root.removeAttribute('data-gen90-reviews-init');
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    var wraps = ctx.querySelectorAll('.gc-reviews__wrap');
    for (var i = 0; i < wraps.length; i++) { initCarousel(wraps[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { if (e.target) { teardown(e.target); } });
})();
